import type { EndpointOIDCUser } from '#dn-types/endpoint-oidc-user.ts';

/** Case-insensitive substring match against every column an admin might be holding a value from. */
export function filterUsers(users: EndpointOIDCUser[], search: string) {
  const term = search.trim().toLowerCase();
  if (!term) {
    return users;
  }
  return users.filter((user) =>
    [user.email, user.subject, user.issuerURL, user.id].some((value) => value.toLowerCase().includes(term))
  );
}
